// extracted by mini-css-extract-plugin
export default {"container":"Question_container__u-D-E","content":"Question_content__eLacN","data":"Question_data__8hnot","qcontent":"Question_qcontent__CWpVA"};